var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.platform.reach",
  title: "EGT Platform — Reach",
  description: "The message lives beside the relationship — newsletters and campaigns from the same customer graph.",
  supportServer: true,
  fields: { reserveUrl: { title: "Reserve URL", type: "uri", description: "Reservation entry point.", required: false } }
});
var P = require("../helpers/egt.platform.sections.js");

exports.render = async function render(options) {
  var reserve = (options && options.reserveUrl) || "/reserve";
  return P.capabilityPage({
    id: "reach", reserve: reserve,
    media: { video: "/vis/getthoseemails.mp4", poster: "/vis/getthoseemails.jpg", width: "1920", height: "1920", parallax: 0.06 },
    eyebrow: "The Universe Platform · Reach",
    title: [ "The message lives beside ", { n: "br" }, "the ", { n: "span", c: "egt__gold", i: "relationship." } ],
    lead: "Newsletters and campaigns drawn from the same customer record as everything else — so they're relevant by default, and always yours to approve.",
    /* SEO wave 2C-5/2C-7 (2026-10-09): answer-first definition, who it's for,
     * and straight answers drawn only from objections the site already answers. */
    answer: "Reach, inside the Universe Platform by EGT, is your email: newsletters and campaigns sent from the same customer record as your site and store, for businesses that want relevant messages without rebuilding their audience in another tool. It's part of the public beta.",
    forTitle: "For businesses that talk to the people they already serve.",
    forWho: [
      { title: "Owners tired of re-importing lists", copy: "The people you email are the people who bought, joined and visited — one audience, not a copy kept in another app." },
      { title: "Teams that want the final say", copy: "Every message waits for your approval. Nothing goes out on its own." },
      { title: "Brands that guard their name", copy: "Your sending reputation is built and kept under your brand — the message is yours end to end." }
    ],
    faq: [
      [ "Does anything send on its own?",
        "No. The system can compose, but it never sends on its own — you approve every message that goes out." ],
      [ "Do I need a separate email tool?",
        "No. Email is built into the platform, so the people you reach are the people you already serve — no re-importing lists into a separate app." ],
      [ "Can I export my data and leave?",
        "Yes. Your customers, orders, content and email list are yours, held as a grant, not a copy. Export them and walk anytime — an integrated core shouldn't mean a locked door." ]
    ],
    spineEyebrow: "What it does",
    spineTitle: "Relevant because it already knows.",
    spineLead: "When the message comes from the same place as the sale and the profile, you don't rebuild your audience in yet another tool.",
    points: [
      { title: "One audience", copy: "No re-importing lists into a separate email app — the people you reach are the people you already serve." },
      { title: "Proposes, never acts", copy: "Nothing sends itself. The system can compose, but it never sends on its own — you approve every message that goes out." },
      { title: "From your own house", copy: "Your sending reputation is built and kept under your brand — the message is yours end to end." }
    ],
    honesty: "One house, one standard.",
    honestyLead: "Reach is built to the same standard as the rest of the system — your audience, your relationships, and your sending reputation, all under one roof. Never a bolt-on.",
    honestyMedia: { img: "/imgs/egt-platform-reach.jpg", alt: "", parallax: true }
  });
};
